import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

export default (field) => ({
    field,
    picker: null,

    init() {
        this.picker = flatpickr(this.$refs.picker, {
            mode: 'range',
            dateFormat: 'm/d/Y',
            defaultDate: this.field,
            onClose: (_, dateString) => {
                if (dateString) {
                    this.field = dateString.split(' to ');
                }
            },
        });

        this.$watch('field', (value, oldValue) => {
            if (oldValue !== undefined && (!value || value.length === 0)) {
                this.picker.clear();
            }
        });
    },

    clear() {
        this.picker.clear();

        this.field = [];
    },

    canClear() {
        return this.field.length > 0;
    },
});
